/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_CustomerPortalShowAsContactPersonToCustomerModes {
    Yes = 10,
    No = 20,
}
